/**
 * Etiquetas de los 8 estados de una prescripción (`PrescriptionModel.status`),
 * compartidas por los reportes de producción (Excel, impresión y filtros).
 */
export const PRESCRIPTION_STATUS_LABELS: Record<string, string> = {
  control: 'Control',
  approved: 'Aprobada',
  rejected: 'Rechazada',
  produced: 'Producción',
  canceled: 'Cancelada',
  issued: 'Expedida',
  delivered: 'Entregada',
  inbox: 'Bandeja de entrada',
};
